import {
    ExperienceRecordCreateDto,
    ExperienceRecordDetailsDto,
    ExperienceRecordUpdateDto,
    MatterExperienceRecordDto,
} from 'types/experience-records.ts';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

export const APIExperienceRecordsSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['ExperienceRecordListItems', 'ExperienceRecord'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getExperienceRecordById: builder.query<ExperienceRecordDetailsDto, string>({
                query: (id) => `/v1/experience-records/${id}`,
                keepUnusedDataFor: 0,
                providesTags: (_result, _error, id) => [{ type: 'ExperienceRecord', id }],
            }),
            getExperienceRecordsWithFilters: accumulatedQueryWithFilters<MatterExperienceRecordDto>(
                builder,
                '/v1/matter-experience-records',
                { providesTags: ['ExperienceRecordListItems'] }
            ),
            addExperienceRecord: builder.mutation<ExperienceRecordDetailsDto, ExperienceRecordCreateDto>({
                query: (body) => ({
                    url: `/v1/experience-records`,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['ExperienceRecordListItems'],
            }),
            updateExperienceRecord: builder.mutation<ExperienceRecordDetailsDto, ExperienceRecordUpdateDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/experience-records/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: (_result, _error, { id }) => [
                    { type: 'ExperienceRecord', id },
                    'ExperienceRecordListItems',
                ],
            }),
            deleteExperienceRecord: builder.mutation<boolean, { id: string }>({
                query: ({ id }) => ({
                    url: `/v1/experience-records/${id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['ExperienceRecordListItems'],
            }),
        }),
        overrideExisting: false,
    });

export const {
    useGetExperienceRecordByIdQuery,
    useGetExperienceRecordsWithFiltersQuery,
    useLazyGetExperienceRecordsWithFiltersQuery,
    useAddExperienceRecordMutation,
    useUpdateExperienceRecordMutation,
    useDeleteExperienceRecordMutation,
} = APIExperienceRecordsSlice;
